module.exports = __webpack_public_path__ + "static/media/tgle-ch.a70304e7.png";